import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { createSelector } from '@ngrx/store';
import { createFeatureSelector } from '@ngrx/store';
import { PublishersState } from 'app/modules/communication-centre/advertiser/store/publishers/publishers.state';
import { PublisherAccount } from 'app/modules/main/models/account';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PublishersSelectors {

  static readonly FEATURE = 'AdvertiserPublishers';

  private readonly feature = createFeatureSelector<PublishersState>(
    PublishersSelectors.FEATURE
  );

  private readonly publishers = createSelector(
    this.feature,
    (state: PublishersState) => state.publishers
  );

  private readonly publishersLoaded = createSelector(
    this.feature,
    (state: PublishersState) => state.publishersLoaded
  );

  constructor(
    private readonly store: Store<PublishersState>
  ) {
  }

  public havePublishersLoaded(): Observable<boolean> {
    return this.store.select(this.publishersLoaded);
  }

  public onPublishersLoaded(): Observable<boolean> {

    return this.havePublishersLoaded()
      .pipe(filter(x => !!x));
  }

  public getPublishers(): Observable<PublisherAccount[]> {

    return this.onPublishersLoaded()
      .pipe(switchMap(() => this.store.select(this.publishers)));
  }

}
